import { render, staticRenderFns } from "./onesupportTickets.vue?vue&type=template&id=577a1b4a&"
import script from "./onesupportTickets.vue?vue&type=script&lang=js&"
export * from "./onesupportTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports